import { IQueryMediator } from 'core-ts-types';
import { IInterface, IInterfaceDTD } from 'utility-js-interface';
import { ORM } from 'utility-ts-orm';
import { PollAnswerDataStore } from '../datastore/poll_answer_datastore';
import { PollDataStore } from '../datastore/poll_datastore';
import { PollStudentDataStore } from './../datastore/poll_student_datastore';
import { IChoiceObject, IStudentAnswerObject } from './../poll_interfaces';

angular
  .module('capability-ng-poll')
  .factory(
    'updatePollAnswerCommand',
    function updatePollAnswerCommandDefinition(
      $q: ng.IQService,
      QueryMediator: IQueryMediator,
      $http: ng.IHttpService,
      ngPollAnswerDataStore: PollAnswerDataStore,
      ngPollDataStore: PollDataStore,
      ngPollStudentDataStore: PollStudentDataStore,
      ngPollResultsServant: any,
      defineCommand: any
    ): void {
      return defineCommand(
        'updatePollAnswerCommand',
        function updatePollAnswerCommand(deferred: ng.IDeferred<any>, answerObject: IStudentAnswerObject): void {
          const url: string = `poll/${answerObject.pollId}/question/${answerObject.questionID}/answers`;
          let payload: any;

          if (_.isArray(answerObject.response)) {
            payload = _.map(answerObject.response, (choice: IChoiceObject) => {
              return { value: choice.nk };
            });
          } else {
            payload = { value: answerObject.response.nk };
          }

          $http
            .post(url, payload)
            .then(({ data }: any): void => {
              ngPollDataStore.answerQuestion(answerObject);
              ngPollAnswerDataStore.add({ answer: data.next_question_answers });
              QueryMediator.runQueries(ngPollAnswerDataStore.updateAnswer(answerObject));
              deferred.resolve(data.next_question_id);
              ngPollDataStore.addBuiltQuestions(
                ngPollResultsServant.buildQuestions(
                  ngPollDataStore.read(),
                  ngPollAnswerDataStore.read(),
                  ngPollStudentDataStore.read()
                )
              );
              ORM.run(ngPollDataStore, ngPollAnswerDataStore, ngPollStudentDataStore);
            })
            .catch((err: any): void => {
              deferred.reject(err);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/commands/update_poll_answer_command.ts